import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// RouterLink removed (template uses manual navigation)
import { CareersService } from '../../services/careers.service';
import { Job } from '../../models/job.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-career',
  imports: [CommonModule, FormsModule],
  templateUrl: './career.html',
  styleUrl: './career.scss'
})
export class Career implements OnInit {
  jobs: Job[] = [];
  loading = false;
  error: string | null = null;
  selectedLocation = '';
  selectedDepartment = '';
  keyword = '';
  locations: string[] = [];
  departments: string[] = [];
  selectedJob: Job | null = null;
  firstName = '';
  lastName = '';
  email = '';
  phone = '';
  resumeFile: File | null = null;
  submitting = false;
  submitSuccess: string | null = null;
  submitError: string | null = null;
  //

  constructor(private careersService: CareersService, private router: Router, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.fetchJobs();
  }

  fetchJobs(companyName?: string) {
    this.loading = true;
    this.error = null;



    // Fallback: if API doesn't respond within 10s, stop the spinner and show a message
    const fallback = setTimeout(() => {
      if (this.loading) {
        this.loading = false;
        this.error = 'Request taking too long. Please try again.';
      }
    }, 10000);

    this.careersService.getCompanyJobList(companyName).subscribe({
      next: data => {
        clearTimeout(fallback);
  //
        this.jobs = data;
        // derive unique locations & departments for filter dropdowns
        const locSet = new Set<string>();
        const deptSet = new Set<string>();
        for (const j of this.jobs) {
          if (j?.job_location) locSet.add(j.job_location);
          if (j?.department) deptSet.add(j.department);
        }
        this.locations = Array.from(locSet).sort();
        this.departments = Array.from(deptSet).sort();
  //
        this.loading = false;
  try { this.cdr.detectChanges(); } catch (e) {}
      },
      error: err => {
        clearTimeout(fallback);
        console.timeEnd('fetchJobs');
        this.error = 'Failed to load jobs';
        this.loading = false;
        console.error(err);
      }
    });
  }

  // Navigate to details; include the job object in navigation state so details page can show immediately
  goToDetails(job: Job) {
    this.router.navigate(['/career', job.id], { state: { job } });
  }

  trackJob = (_: number, job: Job) => job.id;

  get filteredJobs(): Job[] {
    const kw = this.keyword.trim().toLowerCase();
    const filtered = this.jobs.filter(j => {
      if (this.selectedLocation && j.job_location !== this.selectedLocation) return false;
      if (this.selectedDepartment && j.department !== this.selectedDepartment) return false;
      if (kw) {
        const hay = (j.title + ' ' + (j.shortd || '')).toLowerCase();
        if (!hay.includes(kw)) return false;
      }
      return true;
    });
    
    // Auto-select first job if none selected or current selection not in filtered list
    if (filtered.length > 0 && (!this.selectedJob || !filtered.find(j => j.id === this.selectedJob!.id))) {
      setTimeout(() => this.selectedJob = filtered[0], 0);
    }
    
    return filtered;
  }

  selectJob(job: Job) {
    this.selectedJob = job;
    this.submitSuccess = this.submitError = null;
    setTimeout(() => {
      const el = document.getElementById('jobDetailsPanel');
      if (el && window.innerWidth < 992) el.scrollIntoView({behavior:'smooth', block:'start'});
    }, 0);
  }

  onResumeSelected(evt: Event) { const input = evt.target as HTMLInputElement; this.resumeFile = input.files && input.files.length ? input.files[0] : null; }
  get formValid(): boolean { return !!(this.firstName && this.lastName && this.email && this.phone && this.resumeFile && /.+@.+\..+/.test(this.email)); }
  submitApplication() {
    if (!this.formValid || !this.selectedJob) return;
    this.submitting = true; this.submitError = null; this.submitSuccess = null;
    setTimeout(() => {
      this.submitting = false; this.submitSuccess = 'Application submitted successfully.';
      this.firstName = this.lastName = this.email = this.phone = ''; this.resumeFile = null;
    }, 900);
  }
}
